import { render, staticRenderFns } from "./CargoExpenseOccurrenceDropdown.vue?vue&type=template&id=56878c12"
import script from "./CargoExpenseOccurrenceDropdown.vue?vue&type=script&lang=js"
export * from "./CargoExpenseOccurrenceDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports